export const PREVIEW_ITEMS_COUNT = 3;

export const START_PAGE = 0;
export const START_PAGE_SIZE = 10;
